import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Hero from '../components/sections/Hero';
import AboutPreview from '../components/sections/AboutPreview';
import ServicesPreview from '../components/sections/ServicesPreview';
import PonysPreview from '../components/sections/PonysPreview';
import ContactPreview from '../components/sections/ContactPreview';

const HomeContainer = styled.div`
  min-height: 100vh;
`;

const Home = () => {
  return (
    <HomeContainer>
      <Hero />
      <AboutPreview />
      <ServicesPreview />
      <PonysPreview />
      <ContactPreview />
    </HomeContainer>
  );
};

export default Home;